import { render } from "./Invigilators.vue?vue&type=template&id=803814e6"
import script from "./Invigilators.vue?vue&type=script&lang=js"
export * from "./Invigilators.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3774952006/src/application/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__